import { LinkedModelsDockingPanelContent } from "./content/linkedModels/linkedModelsContent";
import { DockingPanel } from "./dockingPanel";
import eventBus from "../eventBus/eventDispatcher";

export class LinkedModelsDockingPanel {
    private readonly panel: DockingPanel;
    private _visible: boolean;

    constructor(container: HTMLElement, modelId: string, projectId: string) {
        this._visible = false;

        const component = <LinkedModelsDockingPanelContent modelId={modelId} projectId={projectId} />;

        const panelWidth = 360;
        const panelHeight = 200;
        const containerRect = container.getBoundingClientRect();

        this.panel = new DockingPanel(container, "dextall-linked-models-docking-panel", "Linked models", component, {
            style: {
                resize: "both",
            },
            dimensionsControl: {
                preventOverlapsWithViewerToolbar: true,
                widthDimensionControl: { value: panelWidth, minValue: panelWidth },
                heightDimensionControl: { value: containerRect.height, minValue: panelHeight },
                topOffset: 4,
                rightOffset: 4,
            },
        });

        this.panel.addVisibilityListener(this.onVisibilityChanged.bind(this));
    }

    get visible() {
        return this._visible;
    }

    setVisible(visibility: boolean) {
        if (this._visible === visibility) {
            return;
        }

        this._visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }

    private onVisibilityChanged(value: boolean) {
        this.setVisible(value);
        eventBus.dispatchEvent({ type: "Dextall.LinkedModels.UI.DockingPanelVisibilityChanged", payload: value });
    }
}
